<template>
    <div class="management">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="skills-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectStudents">
                    <b-button
                        class="btn-users remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="skills-card-body body">
                        <b-card-title title-tag="h5">{{$t('students.students')}}</b-card-title>
                        <div class="muted-text">
                            {{$t('students.view_the_profile_pages_of_various_students_here')}}
                        </div>
                    </b-card-body>
                </b-card>
            </div>

            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="profile-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectInvites">
                    <b-button
                        class="btn-duo-user-chart remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="profile-card-body body">
                        <b-card-title title-tag="h5">{{$t('students.skills')}}</b-card-title>
                        <div class="muted-text">
                            {{$t('students.invite_students_for_skills_and_monitor_their_progress')}}
                        </div>
                    </b-card-body>
                </b-card>
            </div>

            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="profile-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectTestCenter">
                    <b-button
                        class="btn-clipboard-user remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="profile-card-body body">
                        <b-card-title title-tag="h5">{{$t('students.testcenter')}}</b-card-title>
                        <div class="muted-text">{{$t('students.invite_students_for_tests')}}</div>
                    </b-card-body>
                </b-card>
            </div>

            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="hasLasIn">
                <b-card
                    class="profile-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectLasGroupCenter">
                    <b-button
                        class="btn-duo-users-class remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="profile-card-body body">
                        <b-card-title title-tag="h5">{{$t('students.groups')}}</b-card-title>
                        <div class="muted-text">{{$t('students.overview_groups')}}</div>
                    </b-card-body>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-students-index-component',
    props: {
        hasLasIn: {
            type: Boolean,
        },
    },
    methods: {
        redirectStudents() {
            window.location.href = this.routes.studentsProfiles();
        },

        redirectInvites() {
            window.location.href = this.routes.rubricSurvey();
        },
        redirectTestCenter() {
            window.location.href = this.routes.testCenterTeacher();
        },
        redirectLasGroupCenter() {
            window.location.href = this.routes.lasGroupOverview();
        },
    },
};
</script>

<style scoped lang="scss">
.management {
    .row {
        > div {
            margin-bottom: $grid-gutter-width;
        }
    }
}
</style>
